// API 配置文件
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/apiphp';

// 注意：火山引擎 API 密钥已迁移到后端 (apiphp/config.php)
// 前端不再直接调用火山引擎 API，而是通过后端代理
// 这样可以保证 API 密钥的安全性

// 接口地址映射
export const API_ENDPOINTS = {
  login: '/login.php',
  register: '/register.php',
  get_list: '/get_list.php',
  upload: '/upload.php',
  save: '/save.php',
  roadmap: '/roadmap.php',
  content: '/content.php',
  video: '/video.php',
  analytics: '/analytics.php',
  rewrite: '/rewrite.php',
  account: '/account.php',
  mixer: '/mixer.php',
  drama: '/drama.php',
  music: '/music.php',
  workflow: '/workflow.php'
};
